import { Edit } from "@mui/icons-material";
import { Box, Button, IconButton, MenuItem, TextField, Typography } from "@mui/material";
import { getTdsAnalytics } from "api/services/automation/dashboard-tan";
import Table from "components/Table";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { ResType } from "types";
import SearchContainer from "components/SearchContainer";
import { formFilingStatus, incomeTaxForms } from "pages/atom-pro/Tan/constants";
import { getFormsFinancialYears } from "utils/getFinancialYears";
import { useLocation } from "react-router-dom";

const TanTdsFormAnalytics = () => {

  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);

  const location = useLocation();
  const state: any = location.state;
  const [filters, setFilters] = useState<any>({
    formCd: null,
    financialYear: null,
    financialQuarter: null,
    startDate: null,
    endDate: null,
    filingStatus: null,
  });

  const { data, isLoading }: ResType = useQuery(
    ["tan-tds-forms", { ...filters, search, limit: pageCount, offset: page * pageCount, }],
    getTdsAnalytics,
    {
        onSuccess: (res) => {
          setTotalCount(res?.data?.totalRecords);
        },
      }
  );

  useEffect(() => {
    if (state) {
      setFilters({
        ...filters,
        financialQuarter: state?.financialQuarter,
        financialYear: state?.financialYear,
        formCd: state?.formCd,
        filingStatus: state?.filingStatus,
      });
      setPage(0);
    }
  }, [state]);

  const handleFilingTypeChange = (e) => {
    setFilters({ ...filters, filingStatus: e.target.value });
    setPage(0);
  };


  const handleformDescChange = (e) => {
    setFilters({ ...filters, formCd: e.target.value });
    setPage(0);
  };

  const handleQuarterChange = (e) => {
    setFilters({ ...filters, financialQuarter: e.target.value });
    setPage(0);
  };

  const handleFinancialYearChange = (e) => {
    setFilters({ ...filters, financialYear: e.target.value });
    setPage(0);
  };

  const handleSearch = (e) => {
    setPage(0);
    setSearch(e);
  };

  return (
    <Box m={1}>
      <Box pr={2} pl={2} sx={{ display: "flex" }}>
        <Box display="flex">
          <Box ml={1}>
            <TextField
              label="Financial Year*"
              value={filters.financialYear || ""}
              sx={{ width: 100 }}
              onChange={handleFinancialYearChange}
              size="small"
              select
            >
              {getFormsFinancialYears().map((year: string) => (
                <MenuItem key={year} value={year.split("-")[0]}>
                  {year}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box ml={0.5}>
            <TextField
              label="Form Name"
              value={filters.formCd || ""}
              sx={{ width: 120 }}
              onChange={handleformDescChange}
              size="small"
              select
            >
              {incomeTaxForms.map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box ml={0.5}>
            <TextField
              label="Quarter"
              value={filters.financialQuarter || ""}
              sx={{ width: 120 }}
              onChange={handleQuarterChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {["Q1", "Q2", "Q3", "Q4"].map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box ml={0.5} mr={1}>
            <TextField
              label="Filing Status"
              value={filters.filingStatus || ""}
              sx={{ width: 100 }}
              onChange={handleFilingTypeChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {formFilingStatus.map((status, index) => (
                <MenuItem key={index} value={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
        <SearchContainer
          minWidth="250px"
          value={search}
          debounced
          placeHolder="Search by  Name | TAN"
          onChange={handleSearch}
        />
      </Box>
      <Table
        sx={{ height: "80vh" }}
        pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
        data={data?.data?.data || []}
        columns={columns}
        loading={isLoading}
      />
    </Box>
  );
};

function calculateFinancialYear(startYear) {
  const endYear = parseInt(startYear) + 1;
  return startYear + "-" + endYear.toString().slice(2);
}

let columns = [
  {
    key: "refYear",
    title: "Financial Year",
    render: (v) => {
      return <Typography>{v?.refYear ? calculateFinancialYear(v?.refYear) : "-"}</Typography>;
    },
  },
  {
    key: "financialQuarter",
    title: "Quarter",
  },
  {
    key: "id",
    title: "Client Name",
    render: (rowData: any) => <Typography>{rowData?.clientName}</Typography>,
  },
  {
    key: "tanNumber",
    title: "TAN",
  },
//   {
//     key: "dateOfAllotment",
//     title: "Allotment Date",
//     render: (rowData: any) => <Typography>{rowData?.dateOfAllotment ? moment(rowData?.dateOfAllotment).format('DD MMM YYYY') : "-"}</Typography>,

//   },
  {
    key: "formDesc",
    title: "Form Name",
  },
  {
    key: "filingStatus",
    title: "Filing Status",
    render: (rowData: any) => (
      <Typography color={rowData?.filingStatus === 'Not Filed' ? 'red' : 'green'}>{rowData?.filingStatus ? rowData?.filingStatus : "-"}</Typography>
    ),
  },
 
  {
    key: "ackDt",
    title: "Filing Date",
    render: (rowData: any) => <Typography>{rowData?.ackDt ? rowData?.ackDt : "-"}</Typography>,
  },
  {
    key: "tempAckNo",
    title: "RRR#",
    render: (rowData: any) => (
      <Typography>{rowData?.tempAckNo ? rowData?.tempAckNo : "-"}</Typography>
    ),
  },
 
  
];

export default TanTdsFormAnalytics;
